<template>
  <div>
    <world-nav/>
    <b-form-group label="愛称">
      <b-form-input v-model="npc.nickname" />
    </b-form-group>
    <b-form-group label="ステータス">
      <b-container>
        <!-- 固定ステータス -->
        <b-row v-for="(k,j) in chunk4fixStatus" :key="'f'+j">
          <b-col cols="6" v-for="l in k" :key="'fs'+l">
            <b-input-group :prepend="l">
              <b-form-input type="number" v-model="npc.status[l]" 
                number />
            </b-input-group>
          </b-col>
        </b-row>
        <!-- 拡張ステータス -->
        <b-row v-for="(k,j) in chunk4statusWithoutFixStatus(npc)" :key="'o'+j">
          <b-col cols="6" v-for="l in k" :key="'os'+l">
            <b-input-group :prepend="l">
              <b-form-input type="number" v-model="npc.status[l]" 
                number />
              <b-input-group-append>
                <b-button variant="danger" @click="$delete(npc.status, l)">
                  <font-awesome-icon icon="times" class="icon fa-1x" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-input-group>
              <b-form-input v-model="newStatusLabel" 
                :state="okStatusLabel(newStatusLabel)"
                placeholder="ステータス名" />
              <b-input-group-append>
                <b-button @click="newStatus(npc)">
                  <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
                  追加
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-container>          
    </b-form-group>
    <b-form-group id="card" label="使用カード">
      <card-list v-model="selectCard"
        :list="item" :master="cardDict" select
      >
        <template #default="card">
          <b-form-group v-if="card.index > -1" 
            id="cardPerformance" label="演出">
            <b-form-select v-model="diceBattle.event['card'+card.index]" 
              :options="performance" />
          </b-form-group>
        </template>
      </card-list>
    </b-form-group>
    <b-tabs>
      <b-tab title="アイコン">
        <b-form-group id="normal-icon" label="通常アイコン">
          <icon-dropdown :list="iconList" v-model="diceBattle.icon.normal"
            width="60px" height="60px"
          />
        </b-form-group>
      </b-tab>
      <b-tab title="イベント">
        <b-form-group id="died" label="戦闘不能時イベント">
          <b-form-select v-model="diceBattle.event.died" 
            :options="performance" />
        </b-form-group>
        <b-form-group id="normalAttack" label="通常攻撃時">
          <b-form-select v-model="diceBattle.event.normalAttack" 
            :options="performance" />
        </b-form-group>
        <b-form-group id="falter" label="怯み時">
          <b-form-select v-model="diceBattle.event.falter" 
            :options="performance" />
        </b-form-group>
      </b-tab>
      <b-tab title="演出">
        <b-card v-for="(p,k) in diceBattle.performance" :key="k" 
          :title="p.name">
          <b-form-group label="名前" label-cols="3">
            <b-form-input v-model="p.name" debounce="500" />
          </b-form-group>
          <b-form-group label="発言１" label-cols="3">
            <div class="remark">
              <icon-dropdown :list="iconList" v-model="p.icon1"
                width="60px" height="60px"
              />
              <remark-editor class="editor" v-model="p.remark1"
                :danger="1000" :warn="800"
              ></remark-editor>
            </div>
          </b-form-group>
          <b-form-group label="カットイン" label-cols="3">
            <b-form-input placeholder="" v-model="p.cutin" debounce="500" />
            <b-img width="250px" height="75px" :src="p.cutin" fluid />
          </b-form-group>
          <b-form-group label="発言２" class="remark" label-cols="3">
            <div class="remark">
              <icon-dropdown :list="iconList" v-model="p.icon2"
                width="60px" height="60px"
              />
              <remark-editor class="editor" v-model="p.remark2"
                :danger="1000" :warn="800"
              ></remark-editor>
            </div>
          </b-form-group>
        </b-card>
        <b-button size="sm"
          @click="addPerformance">
          <font-awesome-icon icon="plus-square" class="fa-1x p-0" />追加
        </b-button>
      </b-tab>
    </b-tabs>
    <div class="ctrl-bar">
      <b-button type="button" @click="$router.back()">戻る</b-button>
      <!-- <b-button variant="danger" @click="remove">
        <font-awesome-icon icon="times" class="icon fa-1x" />
        このNPCを削除
      </b-button> -->
    </div>
  </div>
</template>

<script>
import WorldNav from '@/components/WorldNav'
import mixinPlayer from './mixin-player'
import _ from 'lodash'
const fixStatus = ['STR','INT','VIT','MND','DEX','AGI','HP','EP']
import CardList from '@/components/CardList'
import IconDropdown from '@/components/IconDropdown'
import RemarkEditor from '@/components/RemarkEditor'
import { cards } from './mixin-editor'
export default {
  components: {
    WorldNav,
    CardList,
    IconDropdown,
    RemarkEditor,
    // ResponseMessage
  },
  mixins: [mixinPlayer,cards],
  props: {
    value: Object,
    postMessage: Object,
    iconList: Array
  },
  computed: {
    areas () {
      return _.map(_.keys(this.innerValue.area), 
        (key)=>{ return { text:this.innerValue.area[key].name, value:key } })
    },
    fixStatus () { return fixStatus },
    chunk4fixStatus () { return _.chunk(fixStatus,2 ) },
    area () { return this.innerValue.area[this.$route.params.area] },
    npc () { return this.area.npc[this.$route.params.key] },
    diceBattle () { return this.npc.diceBattle },
    item () {
      return _.transform(this.cardList, (result, c)=>{
        result.push({
          RID: c.value,
          key: c.value,
          num: 0
        })
      },[])
    },
    selectCard: {
      get () { return this.npc.selectCard },
      set (v) {
        this.npc.selectCard = v
        this.npc.item = {}
        _.map(v, (k)=>{
          this.npc.item[k] = {
            RID: k,
            key: k,
            num: 0
          }
        })
      }
    },
    performance () {
      return _.map(_.keys(this.diceBattle.performance), 
        k=>{ return { value:k, text:this.diceBattle.performance[k].name } })
    }
  },
  data () {
    return {
      innerValue: this.value,
      newStatusLabel: ''
    }
  },
  methods: {
    chunk4statusWithoutFixStatus (v) {
      return _.chunk(_.difference(_.keys(v.status),fixStatus),2)
    },
    newStatus (v) {
      this.$set(v.status,this.newStatusLabel,0)
      this.newStatusLabel = ""
    },
    okStatusLabel (v) {
      return v != ""
    },
    addPerformance () {
      let id = '@'+_.uniqueId()
      this.$set(this.diceBattle.performance,id,{
        name: `演出${_.keys(this.diceBattle.performance).length+1}`,
        remark1: null, remark2: null,
        icon1: null, icon2:null,
        cutin: null
      })
    }
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    }
  },
  filters: {
    ignoreFixStatus (v) {
      return _.difference(_.keys(v),fixStatus)
    }
  }
}
</script>

<style lang="scss" scoped>
.ctrl-bar {
  padding: 10px;

  display: flex;
  justify-content: space-between;
}
</style>